import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-practice-plan-row',
  templateUrl: './practice-plan-row.component.html',
  styleUrls: ['./practice-plan-row.component.scss'],
  standalone: false
})
export class PracticePlanRowComponent {
  @Input() rowForm!: UntypedFormGroup;
  @Input() recordingSetups: Array<{v: any, d: string}> = [];
  @Input() recordingSetupsLoading = false;
  @Input() defaultBufferBefore = 0;
  @Input() defaultBufferAfter = 0;
  @Input() index = 0;
  @Input() submitted = false;

  showPreview = false;

  resetBuffers() {
    this.rowForm.patchValue({
      bufferBefore: this.defaultBufferBefore,
      bufferAfter: this.defaultBufferAfter,
    });
  }

  remove() {
    this.rowForm.parent?.parent; // typed parent access not used directly
  }

  get hasError(): boolean {
    return !!this.rowForm.get('errorMessage')?.value;
  }

  compareSetupRefs = (a: any, b: any): boolean => {
    if (a === b) {
      return true;
    }
    if (!a || !b) {
      return false;
    }
    const aPath = a.path ?? a.id ?? a.v?.path ?? a.v?.id;
    const bPath = b.path ?? b.id ?? b.v?.path ?? b.v?.id;
    return !!aPath && aPath === bPath;
  };
}
